module.exports = __webpack_public_path__ + "media/Video 14b.2f3b9a85.mp4";